import BigNumber from 'bignumber.js';
import { parseToCommon, parseToOrigin, toBigNumber } from './unit';

export class Decimals {
  volume: number;
  amount: number;
  price: number;
}

export enum DepthDirection {
  Bid = 'Bid',
  Ask = 'Ask'
}

export class SwapDepthItem {
  public price: BigNumber;
  public volume: BigNumber;
  constructor(price: BigNumber, volume: BigNumber) {
    this.price = price;
    this.volume = volume;
  }
}
export class SwapDepthCollection {
  direction: DepthDirection;
  private items: SwapDepthItem[];
  constructor(direction: DepthDirection, items: SwapDepthItem[]) {
    this.direction = direction;
    switch (direction) {
      case DepthDirection.Bid:
        this.items = items.sort((a, b) => b.price.comparedTo(a.price));
        break;
      case DepthDirection.Ask:
        this.items = items.sort((a, b) => a.price.comparedTo(b.price));
        break;
    }
  }
  public get depthItems(): SwapDepthItem[] {
    return this.items;
  }

  public get depthDict(): { [key: string]: SwapDepthItem } {
    const dict = {};
    this.items.forEach(item => {
      dict[item.price.toString()] = item;
    });
    return dict;
  }

  public toString(): string {
    let result = `direction: ${this.direction}`;
    this.items.forEach(item => {
      result += `\nprice: ${item.price} volume: ${item.volume}`;
    });
    return result;
  }
}

export class SwapDepth {
  k: BigNumber;
  volume: BigNumber;
  amount: BigNumber;
  decimals: Decimals;
  p0: BigNumber;
  constructor(options: {
    liquidity: bigint;
    volume: bigint;
    amount: bigint;
    decimals: Decimals;
    priceFixed: number;
  }) {
    this.k = toBigNumber(options.liquidity)
      .pow(2)
      .shiftedBy(-(options.decimals.amount + options.decimals.volume));
    this.volume = toBigNumber(options.volume).shiftedBy(
      -options.decimals.volume
    );
    this.amount = toBigNumber(options.amount).shiftedBy(
      -options.decimals.amount
    );
    const a = toBigNumber(options.amount);
    const b = toBigNumber(options.volume);
    this.p0 = new BigNumber(a.div(b).decimalPlaces(options.priceFixed));
    //console.log(this.p0)
    this.decimals = options.decimals;
    //console.log(this)
  }

  public getDepth(options: {
    direction: DepthDirection;
    deltaP: BigNumber;
    maxCount: number;
    minVolume?: BigNumber;
    latestPrice?: BigNumber;
  }): SwapDepthCollection {
    const { direction, deltaP, maxCount, minVolume, latestPrice } = options;
    let items = [];
    let pLast = latestPrice.gt(0) ? latestPrice : this.p0;
    console.debug(
      `pLast: ${pLast.toString()} , latestPrice ${latestPrice.toString()}`
    );
    let volumeLast = new BigNumber(1);
    let index = 0;
    while (index < maxCount && volumeLast.gt(0) && pLast.minus(deltaP).gt(0)) {
      index++;
      const getPriceNow = () => {
        if (direction === DepthDirection.Bid) {
          return pLast.minus(deltaP);
        } else {
          return pLast.plus(deltaP);
        }
      };
      const pNow = getPriceNow();
      const pMin = BigNumber.max(pNow, pLast);
      const pMax = BigNumber.min(pNow, pLast);
      pLast = pNow;

      const b = this.k.div(pMin).squareRoot();
      const a = this.k.div(pMax).squareRoot();
      const volumeNow = a.minus(b);
      if (volumeNow.lte(0)) {
        volumeLast = new BigNumber(0);
      } else {
        volumeLast = volumeNow;
        if (!minVolume || volumeNow.gt(minVolume)) {
          items.push(new SwapDepthItem(pNow, volumeNow));
        }
      }
    }
    return new SwapDepthCollection(direction, items);
  }
}
